/* eslint-disable tailwindcss/no-custom-classname */
import Link from "next/link";
import { FC, useState } from "react";

import { NEXT_URL } from "@/utils/const";

import LogoImg from "/public/logo.svg";
import PoweredbyIcon from "/public/advertisement-poweredby.svg";
import ArrowRightAdvertiseIcon from "/public/icon/arrow_right_advertisement.svg";
import ArrowRightWhiteIcon from "/public/icon/arrow_right_white.svg";
import AdvertisementIcon from "/public/icon/icon_advertisement.svg";

interface Props {
  isSticky: boolean;
}

export const PcAdvertisementFooter: FC<Props> = () => {
  const [isCollapse, setIsCollapse] = useState(false);

  const onClickCollapse = () => {
    setIsCollapse((prev) => !prev);
  };

  return (
    <>
      <div className="flex mt-5">
        <div className="flex items-center justify-center w-[657px] bg-white rounded-lg mx-auto">
          <AdvertisementIcon title="Yoyacoo" className="mx-4" />
          <div className="space-y-[10px] shrink-0">
            <div className="flex flex-row space-x-1">
              <LogoImg width="104" height="20" title="Yoyacoo" />
              <span className="text-[#4C4C4C] text-[12px] font-normal leading-6 tracking-normal">
                なら
              </span>
            </div>
            <div className="w-[132px] border-t border-primary" />
          </div>
          <ArrowRightAdvertiseIcon title="Yoyacoo" className="ml-4" />
          <div className="flex flex-col items-center space-y-4 px-6 py-9 pr-2">
            <div className="text-[#222222] text-[15px] font-normal leading-6 tracking-normal">
              魅力的な申込ページをカンタン作成！
              <br />
              <span className="text-primary font-bold">
                予約、決済、メルマガ、フォーム
              </span>
              <br />
              全てをカンタン・自動化します
            </div>
            <Link
              href={NEXT_URL.SYSTEM_LP_REFERRAL}
              className="flex justify-center items-center bg-[#3ABCA8] gap-x-2 pl-5 pr-4 py-2 rounded-full">

              <span className="text-white text-xs font-bold leading-6 tracking-normal">
                今すぐ無料ではじめる
              </span>
              <ArrowRightWhiteIcon />

            </Link>
          </div>
        </div>
      </div>
      <div
        className={`fixed right-[40px] bg-white rounded-lg shadow-[0px_2px_4px_0px_#D9D9D9] transition-all z-[100] ${
          isCollapse ? "bottom-[-168px]" : "bottom-0"
        } transition-all duration-300`}
      >
        <div className="flex flex-col items-center justify-center">
          <div
            className="flex items-center justify-between w-full border-b border-primary px-4 py-2 cursor-pointer"
            onClick={onClickCollapse}
          >
            <div className="flex grow items-center justify-center space-x-1">
              <PoweredbyIcon title="Powered by" />
            </div>
            <ArrowRightWhiteIcon
              width="20"
              height="20"
              viewBox="0 0 12 12"
              className={`fill-primary ${
                isCollapse ? "-rotate-90" : "rotate-90"
              } transition-all`}
            />
          </div>

          <div
            className={`flex flex-col items-center space-y-4 px-4 pt-6 pb-4`}
          >
            <div className="text-center text-[#222222] text-[15px] font-normal leading-6 tracking-normal">
              魅力的な申込ページをカンタン作成！
              <br />
              <span className="text-primary font-bold">
                予約、決済、メルマガ、フォーム
              </span>
              <br />
              全てをカンタン・自動化します
            </div>
            <Link
              href={NEXT_URL.SYSTEM_LP_REFERRAL}
              className="flex justify-center items-center bg-[#3ABCA8] gap-x-2 pl-5 pr-4 py-2 rounded-full">

              <span className="text-white text-xs font-bold leading-6 tracking-normal">
                今すぐ無料ではじめる
              </span>
              <ArrowRightWhiteIcon />

            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
